import { useAuth } from "app/hooks/contexts/AuthProvider";
import { Navigate, useLocation, Outlet, matchPath } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import routes from "app/routes";

export default function ProtectedRoutes({ children }) {
  const { pathname } = useLocation();
  const { user } = useAuth();

  const isTokenExpired = () => {
    const token = localStorage.getItem("@app:token");
    if (!token) return true;

    const decodedToken = jwtDecode(token.split(" ")[1]);
    const currentTime = Date.now() / 1000;

    return decodedToken.exp < currentTime;
  };

  if (!user || isTokenExpired()) {
    return <Navigate replace to="/login" state={{ from: pathname }} />;
  }

  // Obter as rotas filhas com base no caminho acessado
  const matchingChild = routes[0].children.find((child) => matchPath(child.path, pathname));
  //console.log("matchingChild:", matchingChild);

  // Capturar o valor de auth da rota correspondente
  const auth = matchingChild?.auth;
  //console.log("auth:", auth);

  // Verificar se o usuário tem permissão para acessar a rota
  const userRoles = user?.type || [];
  const isAuthorized = auth ? auth.some((role) => userRoles.includes(role)) : true;

  if (!isAuthorized) {
    return <Navigate to="/forbidden" replace />;
  }

  return children ? children : <Outlet />;
}
